export default function rating(value) {
  let num = Number(value);

  // Backwards compatibility for old ratings
  if (num > 5) {
    num = (num / 100) * 4 + 1;
  }

  // Clamp between 0 and 5
  num = Math.min(Math.max(num, 0), 5);

  return num;
}